/*
 * Selector de talla estilo Zara para la ficha de producto.
 * - Oculta la fila de tallas del tema y deja solo el botón "Añadir".
 * - Al pulsar "Añadir" se despliega un panel con las tallas; al elegir una
 *   disponible se marca el radio del tema (para que precio, galería y URL se
 *   actualicen como siempre) y se envía el formulario, que el propio tema
 *   (product-form.js) manda al carrito.
 * - Si algo falla en la inicialización no se intercepta nada y el botón
 *   se comporta como antes.
 */
(function () {
  var SIZE_NAMES = /talla|size|taille|gr[oö]sse|größe|taglia|tamanho/i;

  function findSizeIndex(optionEls) {
    for (var i = 0; i < optionEls.length; i++) {
      var label = optionEls[i].querySelector('.wt-product__option__title .label');
      if (label && SIZE_NAMES.test(label.textContent)) return i;
    }
    // Sin nombre reconocible: si hay más de una opción asumimos que la última es la talla
    return optionEls.length > 1 ? optionEls.length - 1 : -1;
  }

  function setup(productForm) {
    if (productForm.dataset.zaraReady) return;
    var form = productForm.querySelector('form');
    var button = form && form.querySelector('button[name="add"]');
    var idInput = form && form.querySelector('input[name="id"]');
    var section = productForm.closest('section[data-product-handle]') || productForm.closest('.shopify-section');
    var variantOptions = section && section.querySelector('variant-options');
    if (!form || !button || !idInput || !variantOptions) return;

    var dataEl = variantOptions.querySelector('script[type="application/json"]');
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var optionEls = Array.prototype.slice.call(variantOptions.querySelectorAll('.wt-product__option'));
    var sizeIdx = findSizeIndex(optionEls);
    if (sizeIdx < 0) return;

    var sizeOption = optionEls[sizeIdx];
    var sizeRadios = Array.prototype.slice.call(sizeOption.querySelectorAll('input[type="radio"]'));
    if (!sizeRadios.length) return;

    productForm.dataset.zaraReady = '1';
    productForm.classList.add('zara-add');
    sizeOption.classList.add('zara-add__hidden-option');
    // El resto de opciones (color) se ocultan si solo tienen un valor: no hay nada que elegir
    optionEls.forEach(function (el, i) {
      if (i !== sizeIdx && el.querySelectorAll('input[type="radio"]').length <= 1) {
        el.classList.add('zara-add__hidden-option');
      }
    });

    // Textos según el idioma de la página (la tienda está en es y fr)
    var lang = (document.documentElement.lang || 'es').slice(0, 2).toLowerCase();
    var I18N = {
      es: { add: 'Añadir', pick: 'Selecciona tu talla', soldOut: 'Agotado', close: 'Cerrar' },
      fr: { add: 'Ajouter', pick: 'Sélectionnez votre taille', soldOut: 'Épuisé', close: 'Fermer' }
    };
    var T = I18N[lang] || I18N.es;
    var strings = window.variantStrings || {};
    var soldOutText = strings.soldOut || T.soldOut;
    var addText = T.add;
    var labelSpan = button.querySelector('span');

    // Panel de tallas
    var overlay = document.createElement('div');
    overlay.className = 'zara-add__overlay';
    var panel = document.createElement('div');
    panel.className = 'zara-add__panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', T.pick);
    panel.innerHTML =
      '<div class="zara-add__head"><span>' + T.pick + '</span>' +
      '<button type="button" class="zara-add__close" aria-label="' + T.close + '">&times;</button></div>' +
      '<ul class="zara-add__list"></ul>';
    productForm.appendChild(overlay);
    productForm.appendChild(panel);
    var list = panel.querySelector('.zara-add__list');

    function selectedOthers() {
      // Valores elegidos en el resto de opciones (color, etc.)
      return optionEls.map(function (el, i) {
        if (i === sizeIdx) return null;
        var checked = el.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(sizeValue) {
      var others = selectedOthers();
      return variants.find(function (v) {
        return v.options.every(function (val, i) {
          return i === sizeIdx ? val === sizeValue : (others[i] === null || others[i] === val);
        });
      });
    }

    function anyAvailable() {
      return sizeRadios.some(function (r) { var v = findVariant(r.value); return v && v.available; });
    }

    function render() {
      list.innerHTML = '';
      sizeRadios.forEach(function (radio) {
        var variant = findVariant(radio.value);
        var available = !!(variant && variant.available);
        var li = document.createElement('li');
        li.className = 'zara-add__item' + (available ? '' : ' zara-add__item--soldout');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'zara-add__size';
        btn.disabled = !available;
        btn.innerHTML = '<span class="zara-add__size-name">' + radio.value + '</span>' +
          (available ? '' : '<span class="zara-add__size-note">' + soldOutText + '</span>');
        if (available) {
          btn.addEventListener('click', function () { choose(radio, variant); });
        }
        li.appendChild(btn);
        list.appendChild(li);
      });
    }

    function open() {
      render();
      productForm.classList.add('zara-add--open');
      document.body.classList.add('zara-add-open');
      document.addEventListener('keydown', onKey);
    }

    function close() {
      productForm.classList.remove('zara-add--open');
      document.body.classList.remove('zara-add-open');
      document.removeEventListener('keydown', onKey);
    }

    function onKey(e) { if (e.key === 'Escape') close(); }

    function choose(radio, variant) {
      close();
      // Marcamos el radio del tema para que actualice galería, precio y URL
      if (!radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      idInput.value = variant.id;
      // El tema deshabilita el botón mientras recarga el precio; lo forzamos
      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');
      productForm.dataset.zaraSubmitting = '1';
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      setTimeout(function () { delete productForm.dataset.zaraSubmitting; }, 500);
    }

    // Interceptamos el clic en captura para que no se envíe el formulario sin talla
    button.addEventListener('click', function (e) {
      if (productForm.dataset.zaraSubmitting) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (productForm.classList.contains('zara-add--open')) close(); else open();
    }, true);
    overlay.addEventListener('click', close);
    panel.querySelector('.zara-add__close').addEventListener('click', close);

    // El tema pone "Agotado"/disabled según la variante preseleccionada; con el
    // panel el botón debe poder abrirse siempre que exista alguna talla.
    function normalizeButton() {
      if (productForm.dataset.zaraSubmitting) return;
      if (anyAvailable()) {
        button.removeAttribute('disabled');
        if (labelSpan) labelSpan.textContent = addText;
      } else if (labelSpan) {
        labelSpan.textContent = soldOutText;
      }
    }
    normalizeButton();
    new MutationObserver(normalizeButton).observe(button, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true, characterData: true });
    variantOptions.addEventListener('change', function () { if (productForm.classList.contains('zara-add--open')) render(); });

    // Referencia (SKU) de la línea "COLOR | REFERENCIA" al cambiar de talla
    if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
        var v = e && e.data && e.data.variant;
        var el = section.querySelector('[data-zara-sku]');
        if (v && el && v.sku) el.textContent = v.sku;
      });
    }
  }

  function init() {
    document.querySelectorAll('product-form.wt-product__add-to-cart').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
